// pages/LuxotticaRegisterPage.jsx (or any page file)
import React from 'react';
import RecoveryPage from '@/components/RecoveryPage';
import config from '@/config';
import { buildPath } from '@/utils/routeBuilder';

const LuxotticaRecoveryPage = () => {
  return (
    <RecoveryPage
      projectId="luxottica"
      projectName="Luxottica"
      loginPath={buildPath('/luxottica/login')}
      apiUrl={config.AUTH_API_ADDRESS}
      brandColor="blue"
    />
  );
};

export default LuxotticaRecoveryPage;